import { Link } from 'react-router-dom';
import { ArrowRight, Download, LayoutGrid, QrCode, ShieldCheck } from 'lucide-react';
import './HomeSections.css';

// Timing follows the Terms page (section 5); delivery happens on the order page.
const STEPS = [
  {
    icon: LayoutGrid,
    title: 'Choose a project',
    text: "Each project page lists the stack and exactly what's in the bundle.",
  },
  {
    icon: QrCode,
    title: 'Pay by UPI',
    text: 'Scan the QR code at checkout and pay from any UPI app.',
  },
  {
    icon: ShieldCheck,
    title: 'We verify the payment',
    text: 'Orders are typically processed within 12 hours.',
  },
  {
    icon: Download,
    title: 'Get your files',
    text: 'Downloads and repository access appear on your order page.',
  },
];

const HowItWorks = () => (
  <section className="hs hs--tint" aria-labelledby="hs-steps-title">
    <div className="hs__inner">
      <div className="hs__head">
        <div>
          <h2 id="hs-steps-title" className="hs__title">
            How buying works
          </h2>
          <p className="hs__sub">
            Every payment is verified before your project is unlocked.
          </p>
        </div>
        <Link className="hs__link" to="/how-we-work">
          See the full process
          <ArrowRight aria-hidden="true" />
        </Link>
      </div>

      <ol className="hs-steps">
        {STEPS.map(({ icon: Icon, title, text }) => (
          <li key={title} className="hs-step">
            <span className="hs-step__icon" aria-hidden="true">
              <Icon />
            </span>
            <h3 className="hs-step__title">{title}</h3>
            <p className="hs-step__text">{text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
